<template>
  <TextField
    v-model="value"
    v-bind="$attrs"
    :placeholder="placeholder || display"
  />
</template>

<script>
import TextField from 'Web/Form/Fields/TextField.vue';
import dayjs from 'dayjs';
import { ref, watch, watchEffect } from 'vue';

export default {
  inheritAttrs: false,
  emits: [
    'update:modelValue',
  ],
  components: {
    TextField,
  },
  props: {
    display: {
      type: String,
      default: 'DD.MM.YYYY',
    },
    modelValue: null,
    placeholder: String,
    type: String,
  },
  setup(props, { emit }) {
    const value = ref(props.modelValue);

    let prevModelValue;

    watchEffect(() => {
      if (prevModelValue === props.modelValue)
        return;

      const date = dayjs(props.modelValue);

      if (date.isValid())
        value.value = date.format(props.display);
    });

    watch(() => value.value, value => {
      const date = dayjs(value, props.display, true);

      if (date.isValid())
        value = date.toISOString();

      prevModelValue = value;

      emit('update:modelValue', value);
    });

    return {
      value,
    }
  }
}
</script>
